import React, { useState, useEffect } from 'react';
import {
  Card,
  Container, Row, Button, Modal, FormGroup, Col, Input, Label, Spinner, ModalFooter, ModalBody
} from "reactstrap";
import { Form, Field } from "react-final-form";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import auth from "authProvider";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";

const ProductEdit = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(false);
  const [brands, setBrands] = useState(false);
  const [suppliers, setSuppliers] = useState(false);
  const [result, setResult] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [categoryupdate, setCategoryupdate] = useState(false);
  const [brandupdate, setBrandupdate] = useState(false);
  const [supplierupdate, setSupplierupdate] = useState(false);
  const [selectedOption_unit, setSelectedOption_unit] = useState(false);
  const [open, setOpen] = useState(false);
  const [quantity_count, setQuantity_count] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);



  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  // const required = value => (value ? undefined : 'Required')
  // const mustBeNumber = value => (isNaN(value) ? 'Must be a number' : undefined)
  // const composeValidators = (...validators) => value =>
  //   validators.reduce((error, validator) => error || validator(value), undefined)


  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getPartsOne('products', { id: props.location.state })
      .then(({ data }) => {
        setResult(data);
        setQuantity_count(data.quantity ? data.quantity : 0)
        setBrandupdate(data?.brand?._id)
        setCategoryupdate(data?.category?._id)
        setSupplierupdate(data?.supplier?._id)
        setSelectedOption_unit(data?.unit)
      });
    dataProvider.getList('product_categories/list', { params: { pagination: { page: 1, perPage: 50 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setCategory(data[0].data); })
    dataProvider.getList('brands', { params: { pagination: { page: 1, perPage: 50 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setBrands(data); })
    dataProvider.getList('suppliers', { params: { pagination: { page: 1, perPage: 50 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setSuppliers(data); })

      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }, []);

  const onChangeSelection_updatecat = (e) => { setCategoryupdate(e); };
  const onChangeSelection_updatebrand = (e) => { setBrandupdate(e); };
  const onChangeSelection_updatesupplier = (e) => { setSupplierupdate(e); };

  const onSubmit_update = (values, id) => {
    setLoading(true)

    dataProvider.update('products', {
      id: props.location.state, params: {
        ...values,
        description: values?.description ? values.description : null,
        quantity: values?.quantity ? values?.quantity : null,
        additional_description: values?.additional_description ? values.additional_description : null,
        category: categoryupdate,
        brand: brandupdate,
        supplier: supplierupdate
      }
    })
      .then(({ data }) => {
        setLoading(false)
        history.push("/partsinventory");
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
        alert(error.message)
      });
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const onSubmit_stock = (values) => {
    let num1 = values?.quantity;
    let num2 = quantity_count;
    let count = parseInt(num1) + parseInt(num2);
    dataProvider.update('products', {
      id: props.location.state, params: { quantity: count }
    })
      .then(({ data }) => {
        setLoading(false)
        history.push("/partsinventory");
      })
      .catch(error => {
        setLoading(false)
      });
  };

  if (!result) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h2 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', fontSize: '1.6rem', fontWeight: 600 }}>EDIT PRODUCT</h2>
            </Row>
          </div>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Row>
                <div className="col">
                  <Card className="shadow" style={{ borderRadius: 10 }}>
                    <Col md="12" style={{ display: 'flex', justifyContent: 'flex-end' }}>

                      <div >
                        <Button onClick={() => handleClickOpen()} color={'white'} type="submit" style={{ backgroundColor: 'green', marginLeft: '10px', color: 'white', borderRadius: '10px', border: 0, padding: 10, margin: 10 }} >
                          ADD STOCK
                        </Button>{' '}
                      </div>
                    </Col>
                    <Form
                      //initialValues={result[0]}
                      onSubmit={onSubmit_update}
                      render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} style={{ padding: 20 }} >
                          <div className="pl-lg-4">
                            <Row>
                              <Col md="6">
                                <FormGroup>
                                  <Label for="productname" style={{ fontSize: ' 0.8125rem' }}>product Name</Label>
                                  <Field name="name"
                                    initialValue={result?.name ? result.name : null}
                                  >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          type="text"
                                          {...input}
                                          name="name"
                                          placeholder="Product name"
                                          style={{ color: 'black', borderRadius: 10 }}
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="category">Choose Category</Label>
                                  {/* <IcomoonReact iconSet={iconSet} style={{position: 'absolute', top: 45,right:17}} color="rgb(15 145 187)" size={14} icon="drop-down" /> */}
                                  <Field name="category"
                                    initialValue={categoryupdate}>
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input  {...input} type="select" onChange={(e) => onChangeSelection_updatecat(e.target.value)} name="category" style={{ color: 'black', borderRadius: 10 }}>
                                          {category && category.map(item => (
                                            <option value={item._id}>{item.category}</option>
                                          ))}
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="role">Supplier</Label>
                                  <Field name="supplier" initialValue={supplierupdate} >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input {...input} type="select" onChange={(e) => onChangeSelection_updatesupplier(e.target.value)} style={{ color: 'black', borderRadius: 10 }}>
                                          {suppliers && suppliers.map(item => (
                                            <option value={item._id}>{item.supplier}</option>
                                          ))}
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="brand">Choose Brand</Label>
                                  <Field name="brand"
                                    initialValue={brandupdate}
                                  >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input {...input} type="select" onChange={(e) => onChangeSelection_updatebrand(e.target.value)} name="brand" style={{ color: 'black', borderRadius: 10 }}>
                                          {brands && brands.map(item => (
                                            <option value={item._id}>{item.brand}</option>
                                          ))}
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">SKU</Label>
                                  <Field name="sku"
                                    initialValue={result?.sku ? result.sku : null}
                                  >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="sku"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="145"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              {/* <Col lg="6">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Quantity</Label>
                                  <Field name="quantity">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="quantity"
                                          style={{ color: 'black', borderRadius: 10, backgroundColor: 'transparent' }}
                                          placeholder="50"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col> */}
                              {result?.quantity === 0 ?
                                <Col lg="6">
                                  <FormGroup>
                                    <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Quantity</Label>
                                    <Field name="quantity">
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            type="text"
                                            name="quantity"
                                            disabled
                                            style={{ color: 'black', borderRadius: 10, backgroundColor: 'transparent' }}
                                            placeholder="50"
                                          />
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col> :
                                <Col lg="6">
                                  <FormGroup>
                                    <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Quantity</Label>
                                    <Field name="quantity" initialValue={result?.quantity ? result.quantity : 0} >
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            type="text"
                                            name="quantity"
                                            disabled
                                            style={{ color: 'black', borderRadius: 10, backgroundColor: 'transparent' }}
                                            placeholder="50"
                                          />
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>}
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="price">Current price</Label>
                                  <Field name="price" initialValue={result?.price ? result.price : null} >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="price"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="50"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Purchaise price</Label>
                                  <Field name="purchase_price" initialValue={result?.purchase_price ? result.purchase_price : null} >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="purchase_price"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="50"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} >Unit</Label>
                                  <Field name="unit" initialValue={selectedOption_unit}  >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input {...input} required onChange={(e) => setSelectedOption_unit(e.target.value)} type="select" name="unit" style={{ color: 'black', borderRadius: 10 }}>
                                          <option value="">--select--</option>
                                          <option value="number">Number</option>
                                          <option value="box">Boxes</option>
                                          <option value="packet">Packets</option>
                                          <option value="kg">Kilogram</option>
                                          <option value="liter">Liter</option>
                                          <option value="cm">Centimeter</option>
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="description">Description</Label>
                                  <Field name="description" initialValue={result?.description ? result.description : null}  >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="textarea"
                                          style={{ color: 'black', padding: 30, borderRadius: 10, overflow: 'hidden' }}
                                          placeholder="Description"
                                          name="description"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            {result?.description ?
                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <Label style={{ fontSize: ' 0.8125rem' }}>Additional Description</Label>
                                    <Field name="additional_description" initialValue={result?.additional_description ? result.additional_description : null}>
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            type="textarea"
                                            style={{ color: 'black', padding: 30, borderRadius: 10, overflow: 'hidden' }}
                                            placeholder="Additional Description"
                                            name="additional_description"
                                          />
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row> : null}
                          </div>
                          <div>
                            <Col md="6">
                              <div style={{ paddingBottom: '30px' }}>
                                <Button onClick={loading} disabled={loading} color={'white'} type="submit" style={{ backgroundColor: loading ? 'green' : 'rgb(0 139 183)', marginLeft: '10px', color: 'white', width: '50%', borderRadius: '10px', border: 0, padding: 15, marginTop: 5 }} >
                                  {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                                  SAVE CHANGES
                                </Button>{' '}
                              </div>
                            </Col>
                          </div>
                        </form>
                      )}
                    />

                  </Card>
                </div>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={open}
        >
          <div onClick={() => setOpen(false)} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ textAlign: 'center', backgroundColor: 'rgb(46 124 155)', padding: 20 }}  >
            <h4 style={{ textAlign: "center", marginTop: '20px', marginLeft: 25, color: 'white' }} className="modal-title" id="exampleModalLabel">
              ADD STOCK
            </h4>
          </div>
          <div>
            <Form
              onSubmit={onSubmit_stock}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.8125rem' }}>Stock Quantity</Label>
                          <Field name="quantity">
                            {({ input }) => (
                              <div>
                                <Input
                                  {...input}
                                  required
                                  style={{ color: 'black' }}
                                  type="number"
                                  min="1"
                                  name="quantity"
                                  placeholder="Stock Quantity"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div style={{ paddingLeft: 10, textAlign: 'center' }}>
                    <Button disabled={loading} type="submit" style={{ backgroundColor: 'rgb(46 124 155)', color: 'white', width: '30%', textAlign: 'center', border: 0 }}>
                      {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}SUBMIT</Button>{' '}
                  </div>
                </form>
              )}
            />
          </div>
        </Modal>
      </div>

      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ProductEdit;
